import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import ImportTrucks from '@flc/components/import/trucks';
import ImportTruck from '@flc/components/import/truck';
import Notifications from '@flc/components/notifications/notifications';
import Info from '@src/flc/components/info/info';
import User from '@flc/components/user/user';

import MainLayout from '@flc/main-layout';

import { IUserSession } from '@entities/user-session';
import { UserType } from '@enums/user-type';

interface IAppRoutes {
    userSession: IUserSession;
    appVersion: string | undefined;
}

const AppRoutes = (props: IAppRoutes) => {
    const { userSession, appVersion } = props;

    let defaultRoute = <Route index element={<Navigate replace to={`/flc/import`} />} />;

    return (
        <Routes>
            <Route path='/' element={<MainLayout appVersion={appVersion} />}>
                {defaultRoute}

                <Route path='flc/import' element={<ImportTrucks />} />
                <Route path='flc/import/:id' element={<ImportTruck />} />
                <Route path='flc/notifications' element={<Notifications />} />
                <Route path='flc/info' element={<Info />} />
                <Route path='flc/useraccount' element={<User />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
